import { render, staticRenderFns } from "./ForfaitTypeModificationWarning.vue?vue&type=template&id=5b46f810&"
import script from "./ForfaitTypeModificationWarning.vue?vue&type=script&lang=js&"
export * from "./ForfaitTypeModificationWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ForfaitTypeModificationWarning.vue"
export default component.exports